import { SVG_ENUM } from "../../enums";
import Table from "rc-table";
import React, { useState } from "react";
import { SVG } from "../../shared";
import { MarginType } from "../../types/MarginTypes";
import { useGetMargins } from "../../hooks/margins";
import { AddEditMarginModal } from "../../features";
import "./MarginsPage.scss";

type MarginsPageProps = {};

const MarginsPage: React.FC<MarginsPageProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMargin, setSelectedMargin] = useState<MarginType | null>(null);
  const { data, refetch } = useGetMargins();

  const handleEditMargin = (margin: MarginType) => {
    setSelectedMargin(margin);
    setIsModalOpen(true);
  };

  const formatPriceRange = (margin: MarginType) => {
    if (margin.from === null && margin.to === null) {
      return "Wszystkie ceny";
    } else if (margin.from === null) {
      return `0 - ${margin.to} zł`;
    } else if (margin.to === null) {
      return `${margin.from}+ zł`;
    } else {
      return `${margin.from} - ${margin.to} zł`;
    }
  };

  const handleModalSuccess = () => {
    refetch();
  };

  const Columns = () => [
    {
      title: "PRZEDZIAŁ CENOWY",
      dataIndex: "range",
      key: "range",
      render: (_: any, record: MarginType) => formatPriceRange(record),
    },
    {
      title: "MARŻA",
      dataIndex: "margin",
      key: "margin",
      render: (margin: number) =>
        margin === 1 ? "Brak synchronizacji z allegro" : `x ${margin}`,
    },
    {
      key: "actions",
      render: (_: any, record: MarginType) => (
        <div className="margins__settings">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handleEditMargin(record)}
          >
            <SVG type={SVG_ENUM.EDIT} />
          </div>
        </div>
      ),
    },
  ];

  const MobileColumns = () => [
    {
      title: "Marża",
      dataIndex: "range",
      key: "range",
      render: (_: any, record: MarginType) => (
        <div>
          <div>{formatPriceRange(record)}</div>
          <div>
            Marża:{" "}
            {record.margin === 1
              ? "Brak synchronizacji z allegro"
              : `x${record.margin}`}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="margins-page__header">
        <h1>Zarządzanie marżami</h1>
      </div>

      <Table
        rowKey="id"
        className="margins-table desktop-table"
        data={data || []}
        columns={Columns()}
      />

      <Table
        rowKey="id"
        className="margins-table mobile-table"
        data={data || []}
        columns={MobileColumns()}
        showHeader={false}
      />

      <AddEditMarginModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleModalSuccess}
        margin={selectedMargin}
      />
    </div>
  );
};

export default MarginsPage;
